import { buildEffectiveInlineHardwareSpec } from '@aerialytic/designer-states/core';

export {
  sanitizeInlineHardwareSpec,
  resolveSlotHardwareFromCanvas,
  findPrimaryInverterUsage,
} from '@aerialytic/designer-states/core';

export { buildEffectiveInlineHardwareSpec };

function responseStatus(error) {
  return error?.response?.status ?? error?.status ?? null;
}

export async function retrieveCompanyHardwareWithFallback({
  retrieve,
  id,
  currentHardware = null,
  inlineHardware = null,
  kind,
}) {
  try {
    return { hardware: await retrieve(id), source: 'registered' };
  } catch (error) {
    if (responseStatus(error) !== 404) throw error;

    const inlineFallback = inlineHardware
      ? buildEffectiveInlineHardwareSpec(currentHardware, inlineHardware)
      : null;
    if (inlineFallback) {
      return { hardware: inlineFallback, source: 'inline-fallback' };
    }
    if (currentHardware) {
      return { hardware: currentHardware, source: 'current-fallback' };
    }

    const label = kind === 'inverter' ? 'Inverter' : 'Panel';
    const unavailable = new Error(
      `${label} configuration ${id} is unavailable and no valid fallback is configured`
    );
    unavailable.iframeCode = `IFRAME_${label.toUpperCase()}_HARDWARE_UNAVAILABLE`;
    throw unavailable;
  }
}

export function visibleHardwareCatalog(catalog) {
  if (!Array.isArray(catalog)) return [];
  return catalog.filter((hardware) => hardware?.is_hidden !== true);
}

export async function loadAssignedHardwareCatalog(newEndpoint) {
  if (typeof newEndpoint !== 'function') {
    return { panels: [], inverters: [] };
  }

  const response = await newEndpoint('v2/catalog/').list(
    '?include=panels,inverters'
  );
  const catalog = response?.catalog ?? response;
  return {
    panels: visibleHardwareCatalog(catalog?.panels),
    inverters: visibleHardwareCatalog(catalog?.inverters),
  };
}

export function sameHardwareId(left, right) {
  if (left === undefined || left === null) return false;
  if (right === undefined || right === null) return false;
  return String(left) === String(right);
}

export function findHardwareById(catalog, id) {
  if (!Array.isArray(catalog)) return null;
  return catalog.find((hardware) => sameHardwareId(hardware?.id, id)) || null;
}
